// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/OwnerDerivationRule.yaml
// Generated: 2026-06-14T18:14:47.106Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateOwnerDerivationRule, UpdateOwnerDerivationRule, OwnerDerivationRule } from '@/types/core/OwnerDerivationRule';

/**
 * OwnerDerivationRule Service
 * CRUD operations for OwnerDerivationRule via the ABP API.
 */
export const ownerDerivationRuleService = new EntityService<OwnerDerivationRule, CreateOwnerDerivationRule, UpdateOwnerDerivationRule>(
  '/api/core/ownerderivationrule',
  'OwnerDerivationRule',
);
